document.addEventListener('turbolinks:load', function () {
    if ($('.knowledge-hub.tutorials, .knowledge-hub.pdf_guides, .knowledge-hub.kh_folders').length === 0) {
        return false
    }

    $(document).off('click', '.individual-detail-section .cross-icon').on('click', '.individual-detail-section .cross-icon', function () {
        hideFileDetail($(this))
    });

    function hideFileDetail(fileDetail) {
        var individualDetailSection = $(fileDetail).parents('.individual-detail-section');
        var overallSection = $(individualDetailSection).siblings('.overall-section');

        // Animate overall section to shrink smoothly
        overallSection.animate(
            {width: '100%'},
            500 // duration in ms
        );

        // Show the detail section with a slide-in effect from the right
        individualDetailSection
            .css({
                display: 'none',
                opacity: 1
            })
            .animate(
                {opacity: 0},
                500
            );
    }
});